const overflowCheckQueue = new Set();
// Batch overflow check for all queued elements
function processOverflowQueue() {
    overflowCheckQueue.forEach(el => el._overflowHandler());
}

import debounce from "@helpers/a4d_helpers_timing";
const debouncedGlobalCheck = debounce(() => {
    requestAnimationFrame(processOverflowQueue);
}, 100);

// Add global listeners for scroll and resize events
window.addEventListener('resize', debouncedGlobalCheck);
// window.addEventListener('scroll', debouncedGlobalCheck);


export default {
    // Bind directive to the element
    bind(el, binding) {
        // Function to check for overflow
        const checkOverflow = () => {
            // Access the parent element
            const parent = el.parentNode;
            const threshold = 4; // threshold in pixels

            // Check if the content is overflowing at the top or bottom
            const hasOverflowTop = el.scrollTop > threshold;
            const hasOverflowBottom = (el.scrollHeight - el.scrollTop) > (el.clientHeight + threshold);

            // Check if the content is overflowing
            // const hasVerticalOverflow = el.scrollHeight > el.clientHeight;
            // const hasHorizontalOverflow = el.scrollWidth > el.clientWidth;

            // Toggle classes based on overflow state
            el.classList.toggle('has-overflow-top', hasOverflowTop);
            el.classList.toggle('has-overflow-bottom', hasOverflowBottom);
            // Toggle classes parent for scroll indicators based on overflow state
            if (parent) {
                parent.classList.toggle('child-has-overflow-top', hasOverflowTop);
                parent.classList.toggle('child-has-overflow-bottom', hasOverflowBottom);
            }

            // // Optionally, emit the overflow status
            // if (binding.value && typeof binding.value === 'function') {
            //     binding.value({vertical: hasVerticalOverflow, horizontal: hasHorizontalOverflow});
            // }
        };

        // Use the debounced function from the mixin
        // const debouncedCheckOverflow = vueInstance.debounce(checkOverflow, 100);
        const debouncedCheckOverflow = debounce(checkOverflow, 100);
        // Save overflow handler to element for easy access
        el._overflowHandler = debouncedCheckOverflow;
        // Add event listeners for scroll and resize events if needed
        el.addEventListener('scroll', debouncedCheckOverflow);

        // Set up MutationObserver to watch for changes in the element
        const observer = new MutationObserver((mutations, obs) => {
            debouncedCheckOverflow();
        });
        // Start Observing
        observer.observe(el, { childList: true, subtree: true });
        // Save observer and overflow handler on the element for cleanup
        el._observer = observer;

        overflowCheckQueue.add(el);
    },

    // Unbind to clean up event listeners
    unbind(el) {
        // console.log('unbind');
        el.removeEventListener('scroll', el._overflowHandler);
        // Disconnect Observer to prevent memory leak
        if (el._observer)
             el._observer.disconnect();
        // Remove the element from the observed elements set
        overflowCheckQueue.delete(el);
    }
}
